// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headingH2 {
  text-align: left;
  margin-left: 20px;
  margin-top: 10px;
  font-weight: 400;
  font-size: 26px;
  line-height: 40px;
}

.reportS p {
  text-align: left;
  margin-left: 20px;
}
.reportS {
  /*   */
  margin-top: 70px;
}

.reports {
  font-family: sans-serif;
  color: #7c7c7c;
  text-decoration: none;
}

.reporter {
  font-family: sans-serif;
}

.option {
  cursor: pointer;
  padding-bottom: 5px;
  font-weight: bold;
}

.option:hover {
  color: green;
}

.selected {
  border-bottom: 2px solid #07a6ef;
}
.selected:hover {
  color: black;
  cursor: text;
}

.divider {
  margin: 0 10px;
}

.search-icon {
  padding: 0 10px;
  color: #999;
}

.optionS {
  margin-top: 32px;
}

.hS {
  color: #7c7c7c;
}

@media only screen and (max-width: 768px) {
  .reportS {
    padding: 5px;
  }

  .optionS {
    margin-top: 15px;
  }
}

/* Drivers page — light scoped polish, matches Accounts/Summary */
.drivers-page {
  margin-top: 67px;
  padding: 0 16px 20px;
  box-sizing: border-box;
}

.drivers-page .driversToolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 12px;
  flex-wrap: nowrap;
}

.drivers-page .headS {
  margin: 0;
  color: #0f172a;
  font-weight: 700;
  font-size: 24px;
  line-height: 1.3;
  white-space: nowrap;
  flex-shrink: 0;
}

.drivers-page .reports {
  color: #0f172a;
  text-decoration: none;
  font-weight: 700;
  font-size: 24px;
}

.drivers-page .reports:hover {
  color: #07a6ef;
}

.drivers-page .crumbSep {
  margin: 0 6px;
  color: #94a3b8;
  font-weight: 600;
  font-size: 20px;
}

.drivers-page .reporter {
  color: #0f172a;
  font-weight: 700;
  font-size: 24px;
}

.drivers-page .driversFilters {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: nowrap;
  margin-left: auto;
}

.drivers-page .searchbarrs,
.drivers-page .dropdownO {
  width: 150px;
  height: 36px;
  margin: 0;
  padding: 0 10px;
  font-size: 13px;
  color: #0f172a;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  box-sizing: border-box;
}

.drivers-page .optionS {
  margin: 0 0 10px;
  text-align: left;
}

.drivers-page .option {
  color: #334155;
  font-size: 14px;
  font-weight: 700;
}

.drivers-page .option:hover {
  color: #07a6ef;
}

.drivers-page .selected {
  color: #07a6ef;
  border-bottom: 2px solid #07a6ef;
}

.drivers-page .Stb {
  width: 100%;
  margin: 0;
}

.drivers-page .Wth,
.drivers-page .Wthh {
  color: #334155;
  font-size: 12px !important;
  font-weight: 700 !important;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb !important;
  padding: 12px 14px !important;
  white-space: nowrap;
}

.drivers-page .Wtd {
  color: #475569;
  font-size: 13px !important;
  font-weight: 500 !important;
  border-bottom: 1px solid #f1f5f9 !important;
  padding: 12px 14px !important;
}

.drivers-page .bS {
  min-width: 70px;
  height: 30px;
  padding: 0 10px;
  font-size: 13px;
  font-weight: 600;
  background: #79c6e9;
  border-radius: 6px;
}

@media (max-width: 900px) {
  .drivers-page .driversToolbar {
    flex-wrap: wrap;
  }

  .drivers-page .driversFilters {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-left: 0;
  }
}

@media (max-width: 600px) {
  .drivers-page {
    margin-top: 50px;
    padding: 0 8px 16px;
  }

  .drivers-page .headS,
  .drivers-page .reports,
  .drivers-page .reporter {
    font-size: 20px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Css/Driver.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,iEAAiE;AACjE;EACE,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,2CAA2C;EAC3C,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,2BAA2B;IAC3B,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;;IAGE,eAAe;EACjB;AACF","sourcesContent":[".headingH2 {\r\n  text-align: left;\r\n  margin-left: 20px;\r\n  margin-top: 10px;\r\n  font-weight: 400;\r\n  font-size: 26px;\r\n  line-height: 40px;\r\n}\r\n\r\n.reportS p {\r\n  text-align: left;\r\n  margin-left: 20px;\r\n}\r\n.reportS {\r\n  /*   */\r\n  margin-top: 70px;\r\n}\r\n\r\n.reports {\r\n  font-family: sans-serif;\r\n  color: #7c7c7c;\r\n  text-decoration: none;\r\n}\r\n\r\n.reporter {\r\n  font-family: sans-serif;\r\n}\r\n\r\n.option {\r\n  cursor: pointer;\r\n  padding-bottom: 5px;\r\n  font-weight: bold;\r\n}\r\n\r\n.option:hover {\r\n  color: green;\r\n}\r\n\r\n.selected {\r\n  border-bottom: 2px solid #07a6ef;\r\n}\r\n.selected:hover {\r\n  color: black;\r\n  cursor: text;\r\n}\r\n\r\n.divider {\r\n  margin: 0 10px;\r\n}\r\n\r\n.search-icon {\r\n  padding: 0 10px;\r\n  color: #999;\r\n}\r\n\r\n.optionS {\r\n  margin-top: 32px;\r\n}\r\n\r\n.hS {\r\n  color: #7c7c7c;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n  .reportS {\r\n    padding: 5px;\r\n  }\r\n\r\n  .optionS {\r\n    margin-top: 15px;\r\n  }\r\n}\r\n\r\n/* Drivers page — light scoped polish, matches Accounts/Summary */\r\n.drivers-page {\r\n  margin-top: 67px;\r\n  padding: 0 16px 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.drivers-page .driversToolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin: 0 0 12px;\r\n  flex-wrap: nowrap;\r\n}\r\n\r\n.drivers-page .headS {\r\n  margin: 0;\r\n  color: #0f172a;\r\n  font-weight: 700;\r\n  font-size: 24px;\r\n  line-height: 1.3;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.drivers-page .reports {\r\n  color: #0f172a;\r\n  text-decoration: none;\r\n  font-weight: 700;\r\n  font-size: 24px;\r\n}\r\n\r\n.drivers-page .reports:hover {\r\n  color: #07a6ef;\r\n}\r\n\r\n.drivers-page .crumbSep {\r\n  margin: 0 6px;\r\n  color: #94a3b8;\r\n  font-weight: 600;\r\n  font-size: 20px;\r\n}\r\n\r\n.drivers-page .reporter {\r\n  color: #0f172a;\r\n  font-weight: 700;\r\n  font-size: 24px;\r\n}\r\n\r\n.drivers-page .driversFilters {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n  flex-wrap: nowrap;\r\n  margin-left: auto;\r\n}\r\n\r\n.drivers-page .searchbarrs,\r\n.drivers-page .dropdownO {\r\n  width: 150px;\r\n  height: 36px;\r\n  margin: 0;\r\n  padding: 0 10px;\r\n  font-size: 13px;\r\n  color: #0f172a;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  background: #fff;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.drivers-page .optionS {\r\n  margin: 0 0 10px;\r\n  text-align: left;\r\n}\r\n\r\n.drivers-page .option {\r\n  color: #334155;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n}\r\n\r\n.drivers-page .option:hover {\r\n  color: #07a6ef;\r\n}\r\n\r\n.drivers-page .selected {\r\n  color: #07a6ef;\r\n  border-bottom: 2px solid #07a6ef;\r\n}\r\n\r\n.drivers-page .Stb {\r\n  width: 100%;\r\n  margin: 0;\r\n}\r\n\r\n.drivers-page .Wth,\r\n.drivers-page .Wthh {\r\n  color: #334155;\r\n  font-size: 12px !important;\r\n  font-weight: 700 !important;\r\n  background: #f8fafc;\r\n  border-bottom: 1px solid #e5e7eb !important;\r\n  padding: 12px 14px !important;\r\n  white-space: nowrap;\r\n}\r\n\r\n.drivers-page .Wtd {\r\n  color: #475569;\r\n  font-size: 13px !important;\r\n  font-weight: 500 !important;\r\n  border-bottom: 1px solid #f1f5f9 !important;\r\n  padding: 12px 14px !important;\r\n}\r\n\r\n.drivers-page .bS {\r\n  min-width: 70px;\r\n  height: 30px;\r\n  padding: 0 10px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  background: #79c6e9;\r\n  border-radius: 6px;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .drivers-page .driversToolbar {\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  .drivers-page .driversFilters {\r\n    width: 100%;\r\n    justify-content: flex-start;\r\n    flex-wrap: wrap;\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .drivers-page {\r\n    margin-top: 50px;\r\n    padding: 0 8px 16px;\r\n  }\r\n\r\n  .drivers-page .headS,\r\n  .drivers-page .reports,\r\n  .drivers-page .reporter {\r\n    font-size: 20px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
